import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { conwayNhConfig } from "./data";

export default function ConwayNhPage() {
  return <CityPageTemplate config={conwayNhConfig} />;
}